module.exports = __webpack_public_path__ + "img/Juan Guillen.d49a70e3.jpg";